import { render } from "./DynvibeDynamicEvolution.vue?vue&type=template&id=2cf5f79f"
import script from "./DynvibeDynamicEvolution.vue?vue&type=script&lang=js"
export * from "./DynvibeDynamicEvolution.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__